const VARIANTS = {
  primary: "btnPri",
  secondary: "btnSec",
  tertiary: "btnTri",
  dark: "btnDark",
};

const Button = ({
  children,
  disabled = false,
  loading = false,
  variant = "primary",
  className,
  ...props
}) => {
  const classNames = [VARIANTS[variant], className];
  if (disabled) {
    classNames.push("btnDis");
  }
  if (loading) {
    classNames.push("button--loading");
  }
  return (
    <button className={classNames.join(" ")} {...props}>
      {children}
    </button>
  );
};

export default Button;
